import React, { useRef } from "react";
import { Button } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormControl, Input, InputLabel } from "@mui/material";

const HideDomainModal = (props) => {
	
	const reason = useRef(null);
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleSubmit = () => {
		props.domain.hidden = true;
		props.domain.hiddenReason = reason.current.value;
		props.onSubmit(props.domain);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleSubmit();
	};
	
	const handleCancel = () => {
		props.onClose()
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	return (
		<Dialog
			open={props.domain? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Hide {props.domain? props.domain.address : "Domain"}
			</DialogTitle>
			<DialogContent>
				<form onSubmit={handleSubmitForm} autoComplete="off">
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="reason">Reason</InputLabel>
						<Input
							inputRef={reason}
							id="reason"
							type="text"
							autoComplete="off"
							defaultValue={props.domain? props.domain.hiddenReason : ""}
						/>
					</FormControl>
				</form>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleSubmit} autoFocus>Submit</Button>
			</DialogActions>
		</Dialog>
	);
};

export default HideDomainModal;